export const CPF_CNPJ = 'cpfcnpj';
export const CPF = 'cpf';
export const CNPJ = 'cnpj';

export const NAME = 'name';
export const NICKNAME = 'nickname';
export const BORN_AT = 'born_at';

export const COMPANY_ACTIVITY_ID = 'company_activity_id';
export const JOINT_STOCK_CENTS = 'joint_stock_cents';
export const IE = 'ie';
export const IM = 'im';

export const MONTHLY_BILLINGS_1_BILLING_CENTS = 'monthly_billings_1_billing_cents';
export const MONTHLY_BILLINGS_1_MONTH = 'monthly_billings_1_month';
export const MONTHLY_BILLINGS_1_YEAR = 'monthly_billings_1_year';

export const MONTHLY_BILLINGS_2_BILLING_CENTS = 'monthly_billings_2_billing_cents';
export const MONTHLY_BILLINGS_2_MONTH = 'monthly_billings_2_month';
export const MONTHLY_BILLINGS_2_YEAR = 'monthly_billings_2_year';

export const MONTHLY_BILLINGS_3_BILLING_CENTS = 'monthly_billings_3_billing_cents';
export const MONTHLY_BILLINGS_3_MONTH = 'monthly_billings_3_month';
export const MONTHLY_BILLINGS_3_YEAR = 'monthly_billings_3_year';

export const MONTHLY_BILLINGS_4_BILLING_CENTS = 'monthly_billings_4_billing_cents';
export const MONTHLY_BILLINGS_4_MONTH = 'monthly_billings_4_month';
export const MONTHLY_BILLINGS_4_YEAR = 'monthly_billings_4_year';

export const MONTHLY_BILLINGS_5_BILLING_CENTS = 'monthly_billings_5_billing_cents';
export const MONTHLY_BILLINGS_5_MONTH = 'monthly_billings_5_month';
export const MONTHLY_BILLINGS_5_YEAR = 'monthly_billings_5_year';

export const MONTHLY_BILLINGS_6_BILLING_CENTS = 'monthly_billings_6_billing_cents';
export const MONTHLY_BILLINGS_6_MONTH = 'monthly_billings_6_month';
export const MONTHLY_BILLINGS_6_YEAR = 'monthly_billings_6_year';

export const MONTHLY_BILLINGS_7_BILLING_CENTS = 'monthly_billings_7_billing_cents';
export const MONTHLY_BILLINGS_7_MONTH = 'monthly_billings_7_month';
export const MONTHLY_BILLINGS_7_YEAR = 'monthly_billings_7_year';

export const MONTHLY_BILLINGS_8_BILLING_CENTS = 'monthly_billings_8_billing_cents';
export const MONTHLY_BILLINGS_8_MONTH = 'monthly_billings_8_month';
export const MONTHLY_BILLINGS_8_YEAR = 'monthly_billings_8_year';

export const MONTHLY_BILLINGS_9_BILLING_CENTS = 'monthly_billings_9_billing_cents';
export const MONTHLY_BILLINGS_9_MONTH = 'monthly_billings_9_month';
export const MONTHLY_BILLINGS_9_YEAR = 'monthly_billings_9_year';

export const MONTHLY_BILLINGS_10_BILLING_CENTS = 'monthly_billings_10_billing_cents';
export const MONTHLY_BILLINGS_10_MONTH = 'monthly_billings_10_month';
export const MONTHLY_BILLINGS_10_YEAR = 'monthly_billings_10_year';

export const MONTHLY_BILLINGS_11_BILLING_CENTS = 'monthly_billings_11_billing_cents';
export const MONTHLY_BILLINGS_11_MONTH = 'monthly_billings_11_month';
export const MONTHLY_BILLINGS_11_YEAR = 'monthly_billings_11_year';

export const MONTHLY_BILLINGS_12_BILLING_CENTS = 'monthly_billings_12_billing_cents';
export const MONTHLY_BILLINGS_12_MONTH = 'monthly_billings_12_month';
export const MONTHLY_BILLINGS_12_YEAR = 'monthly_billings_12_year';

export const GENRE_ID = 'genre_id';
export const EDUCATION_ID = 'education_id';
export const PROPERTY = 'property';
export const PUBLIC_PERSON = 'public_person';

export const EMAIL_ADDRESS = 'email_address';

export const ADDRESS_CITY = 'address_city';
export const ADDRESS_NUMBER = 'address_number';
export const ADDRESS_STREET = 'address_street';
export const ADDRESS_ZIP_CODE = 'address_zip_code';
export const ADDRESS_COMPLEMENT = 'address_complement';
export const ADDRESS_STATE_ID = 'address_state_id';
export const ADDRESS_NEIGHBORHOOD = 'address_neighborhood';
export const ADDRESS_SET_TIME_FULL = 'address_set_time_full';
export const ADDRESS_SET_TIME_MONTH = 'address_set_time_month';
export const ADDRESS_SET_TIME_YEAR = 'address_set_time_year';
export const ADDRESS_BUILD_TYPE_ID = 'address_build_type_id';
export const ADDRESS_RENT_VALUE_CENTS = 'address_rent_value_cents';

export const ALTERNATIVE_ADDRESS_CITY = 'alternative_address_city';
export const ALTERNATIVE_ADDRESS_NUMBER = 'alternative_address_number';
export const ALTERNATIVE_ADDRESS_STREET = 'alternative_address_street';
export const ALTERNATIVE_ADDRESS_ZIP_CODE = 'alternative_address_zip_code';
export const ALTERNATIVE_ADDRESS_COMPLEMENT = 'alternative_address_complement';
export const ALTERNATIVE_ADDRESS_STATE_ID = 'alternative_address_state_id';
export const ALTERNATIVE_ADDRESS_NEIGHBORHOOD = 'alternative_address_neighborhood';
export const ALTERNATIVE_ADDRESS_SET_TIME_FULL = 'alternative_address_set_time_full';
export const ALTERNATIVE_ADDRESS_SET_TIME_MONTH = 'alternative_address_set_time_month';
export const ALTERNATIVE_ADDRESS_SET_TIME_YEAR = 'alternative_address_set_time_year';
export const ALTERNATIVE_ADDRESS_BUILD_TYPE_ID = 'alternative_address_build_type_id';
export const ALTERNATIVE_ADDRESS_RENT_VALUE_CENTS = 'alternative_address_rent_value_cents';

export const PREVIOUS_ADDRESS_CITY = 'previous_address_city';
export const PREVIOUS_ADDRESS_NUMBER = 'previous_address_number';
export const PREVIOUS_ADDRESS_STREET = 'previous_address_street';
export const PREVIOUS_ADDRESS_ZIP_CODE = 'previous_address_zip_code';
export const PREVIOUS_ADDRESS_COMPLEMENT = 'previous_address_complement';
export const PREVIOUS_ADDRESS_STATE_ID = 'previous_address_state_id';
export const PREVIOUS_ADDRESS_NEIGHBORHOOD = 'previous_address_neighborhood';

export const NATIONALITY = 'nationality';
export const PLACE_OF_BIRTH = 'place_of_birth';
export const STATE_OF_BIRTH_ID = 'state_of_birth_id';

export const MOTHER = 'mother';
export const FATHER = 'father';

export const DOCUMENT_TYPE = 'document_type';
export const RG = 'rg';
export const RG_DATE = 'rg_date';
export const RG_STATE_ID = 'rg_state_id';
export const RG_ISSUING = 'rg_issuing';
export const HAS_CNH = 'has_cnh';
export const CNH = 'cnh';
export const CNH_TYPE_ID = 'cnh_type_id';

export const MARITAL_STATUS_ID = 'marital_status_id';
export const SPOUSE_NAME = 'spouse_name';
export const SPOUSE_BORN_AT = 'spouse_born_at';
export const SPOUSE_CPF = 'spouse_cpf';
export const SPOUSE_INCOME_CENTS = 'spouse_income_cents';

export const PERSONAL_REFERENCE_NAME = 'personal_reference_name';
export const PERSONAL_REFERENCE_RELATIONSHIP = 'personal_reference_relationship';
export const PERSONAL_REFERENCE_CITY = 'personal_reference_city';
export const PERSONAL_REFERENCE_PHONE_FULL = 'personal_reference_phone_full';
export const PERSONAL_REFERENCE_PHONE_CODE = 'personal_reference_phone_code';
export const PERSONAL_REFERENCE_PHONE_NUMBER = 'personal_reference_phone_number';

export const PARTNER_NAME = 'partner_name';
export const PARTNER_CPF_CNPJ = 'partner_cpf_cnpj';
export const PARTNER_CPF = 'partner_cpf';
export const PARTNER_CNPJ = 'partner_cnpj';
export const PARTNER_ROLE = 'partner_role';
export const PARTNER_QUOTA = 'partner_quota';
export const PARTNER_BORN_AT = 'partner_born_at';
export const PARTNER_STARTED_AT = 'partner_started_at';
export const PARTNER_INCOME_CENTS = 'partner_income_cents';
export const PARTNER_MARITAL_STATUS_ID = 'partner_marital_status_id';
export const PARTNER_SPOUSE_NAME = 'partner_spouse_name';
export const PARTNER_SPOUSE_CPF = 'partner_spouse_cpf';
export const PARTNER_SPOUSE_BORN_AT = 'partner_spouse_born_at';

export const CELPHONE_FULL = 'celphone_full';
export const CELPHONE_CODE = 'celphone_code';
export const CELPHONE_NUMBER = 'celphone_number';
export const CELPHONE_CONFIRMATION_ID = 'celphone_confirmation_id';

export const ALTERNATIVE_PHONE_FULL = 'alternative_phone_full';
export const ALTERNATIVE_PHONE_CODE = 'alternative_phone_code';
export const ALTERNATIVE_PHONE_NUMBER = 'alternative_phone_number';
export const ALTERNATIVE_PHONE_CONFIRMATION_ID = 'alternative_phone_confirmation_id';

export const JOB_REFERENCE_JOINED_AT = 'job_reference_joined_at';
export const JOB_REFERENCE_INCOME_CENTS = 'job_reference_income_cents';
export const JOB_REFERENCE_ANOTHER_INCOME_CENTS = 'job_reference_another_income_cents';
export const JOB_REFERENCE_ANOTHER_INCOME_TYPE_ID = 'job_reference_another_income_type_id';
export const JOB_REFERENCE_DETAIL = 'job_reference_detail';
export const JOB_REFERENCE_FIRST_JOB = 'job_reference_first_job';
export const JOB_REFERENCE_PROFESSIONAL_OCUPATION_ID = 'job_reference_professional_ocupation_id';
export const JOB_REFERENCE_PROFESSION_ID = 'job_reference_profession_id';
export const JOB_REFERENCE_DEPARTMENT = 'job_reference_department';
export const JOB_REFERENCE_NAME = 'job_reference_name';
export const JOB_REFERENCE_CNPJ = 'job_reference_cnpj';
export const JOB_REFERENCE_COMPANY_ACTIVITY_ID = 'job_reference_company_activity_id';

export const JOB_REFERENCE_ADDRESS_CITY = 'job_reference_address_city';
export const JOB_REFERENCE_ADDRESS_NUMBER = 'job_reference_address_number';
export const JOB_REFERENCE_ADDRESS_STREET = 'job_reference_address_street';
export const JOB_REFERENCE_ADDRESS_ZIP_CODE = 'job_reference_address_zip_code';
export const JOB_REFERENCE_ADDRESS_COMPLEMENT = 'job_reference_address_complement';
export const JOB_REFERENCE_ADDRESS_STATE_ID = 'job_reference_address_state_id';
export const JOB_REFERENCE_ADDRESS_NEIGHBORHOOD = 'job_reference_address_neighborhood';

export const JOB_REFERENCE_PHONE_FULL = 'job_reference_phone_full';
export const JOB_REFERENCE_PHONE_CODE = 'job_reference_phone_code';
export const JOB_REFERENCE_PHONE_NUMBER = 'job_reference_phone_number';

export const JOB_REFERENCE_PREVIOUS_WORK = 'previous_work';
export const JOB_REFERENCE_PREVIOUS_WORK_START_AT = 'previous_work_start_at';
export const JOB_REFERENCE_PREVIOUS_WORK_END_AT = 'previous_work_end_at';

export const JOB_REFERENCE_PREVIOUS_JOB_PHONE_FULL = 'previous_job_phone_full';
export const JOB_REFERENCE_PREVIOUS_JOB_PHONE_CODE = 'previous_job_phone_code';
export const JOB_REFERENCE_PREVIOUS_JOB_PHONE_NUMBER = 'previous_job_phone_number';

export const ACCOUNTANT_NAME = 'accountant_name';
export const ACCOUNTANT_CITY = 'accountant_city';
export const ACCOUNTANT_PHONE_FULL = 'accountant_phone_full';
export const ACCOUNTANT_PHONE_CODE = 'accountant_phone_code';
export const ACCOUNTANT_PHONE_NUMBER = 'accountant_phone_number';

export const HAVE_CREDIT_CARD = 'have_credit_card';
export const CREDIT_CARDS = 'credit_cards';
export const HAS_MADE_FUNDING = 'has_made_funding';
export const PREVIOUS_FUNDING_BANK_ID = 'previous_funding_bank_id';

export const HAVE_BANK_ACCOUNT = 'have_bank_account';
export const BANK_REFERENCE_BANK_ID = 'bank_reference_bank_id';
export const BANK_REFERENCE_OVERDRAFT = 'bank_reference_overdraft';
export const BANK_REFERENCE_AGENCY = 'bank_reference_agency';
export const BANK_REFERENCE_ACCOUNT_FULL = 'bank_reference_account_full';
export const BANK_REFERENCE_ACCOUNT_DIGIT = 'bank_reference_account_digit';
export const BANK_REFERENCE_ACCOUNT_NUMBER = 'bank_reference_account_number';
export const BANK_REFERENCE_OPEN_AT = 'bank_reference_open_at';

export const ACCEPT_BOLETO = 'accept_boleto';
export const NOTE = 'note';
